export const ON_STORY_GROUP_SELECTED = "on_story_group_selected";
export const ON_STORY_YEAR_SELECTED = "on_story_year_selected";
export const ON_ADD_STORY_GROUP_YEAR = "on_add_story_group_year";
export const ON_STORY_GROUP_DELETED = "on_story_group_deleted";
export const ON_SAVE_STORIES_SUCCESSFUL = "on_save_stories_successful";
export const ON_SAVE_STORIES_ERROR = "on_save_stories_error";
export const ON_STORIES_MEETING_SELECTED = "on_stories_meeting_selected";
export const ON_CONNECT_STORIES_TO_MEETING_SUCCESSFUL = "on_connect_stories_to_meeting_successful";